import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Button } from 'antd';
import {
  DashboardOutlined,
  UploadOutlined,
  AppstoreOutlined,
  LogoutOutlined,
  TableOutlined,
} from '@ant-design/icons';

import { useAuth } from '../../context/AuthContext';
import logo from '../../assets/logo.png';

const { Sider, Content } = Layout;

export default function DsmMinLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { key: '/dsm-minimization', icon: <DashboardOutlined />, label: 'DSM Minimization' },
    { key: '/dsm-minimization/raw-data', icon: <TableOutlined />, label: 'Raw Data Table' },
    { key: '/dsm-minimization/ingestion', icon: <UploadOutlined />, label: 'Excel Ingestion' },
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <style>{`
        .ant-menu-item .ant-menu-title-content {
          white-space: nowrap !important;
          overflow: visible !important;
          text-overflow: unset !important;
        }
      `}</style>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        width={260}
        theme="light"
        style={{
          borderRight: '1px solid #e2e8f0',
          position: 'sticky',
          top: 0,
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div
          style={{
            padding: collapsed ? '16px 8px' : 16,
            textAlign: 'center',
            borderBottom: '1px solid #e2e8f0',
            transition: 'all 0.2s',
          }}
        >
          <img
            src={logo}
            alt="Apraava"
            style={{
              height: collapsed ? 20 : 28,
              width: 'auto',
              maxWidth: '100%',
              transition: 'all 0.2s',
            }}
          />
        </div>
        <div style={{ flex: 1, overflowY: 'auto' }}>
          <Menu
            mode="inline"
            selectedKeys={[location.pathname]}
            items={menuItems}
            onClick={({ key }) => navigate(key)}
            style={{ border: 'none', fontSize: 14 }}
          />
        </div>
        <div style={{ padding: 12, borderTop: '1px solid #e2e8f0' }}>
          <Button
            icon={<AppstoreOutlined />}
            onClick={() => navigate('/app-selection')}
            block
            style={{ fontSize: 14, marginBottom: 8 }}
          >
            {!collapsed && 'Switch App'}
          </Button>
          <Button
            icon={<LogoutOutlined />}
            onClick={logout}
            block
            danger
            ghost
            style={{ fontSize: 14 }}
          >
            {!collapsed && 'Logout'}
          </Button>
        </div>
      </Sider>

      <Layout style={{ background: '#fff' }}>
        <Content className="dsm-min-layout-content" style={{ margin: 0, padding: 0, background: '#fff', minHeight: '100vh' }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
